<template>
  <div v-if="activeTab() === hash">
    <slot />
  </div>
</template>

<script>
export default {
  inject: ['activeTab'],
  props: {
    title: {
      type: String,
      required: true,
    },
    hash: {
      type: String,
      required: true,
    },
    isNewSubmodule: {
      type: Boolean,
      required: false
    }
  },
}
</script>
